import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tit-h2" }
const _hoisted_2 = { class: "btn-group" }

import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerView',
  setup(__props) {

const route = useRoute()

const current = ref(route.name)

watch(route, () => {
  current.value = route.name
})

const menuList = {
  CustomerAdd: { title: '고객 추가', label: '고객 추가' },
  CustomerManage: { title: '고객 관리', label: '고객 관리' },
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (current.value === 'CustomerManage')
      ? (_openBlock(), _createElementBlock("header", {
          key: 0,
          class: _normalizeClass(["page-header", current.value.toLowerCase()])
        }, [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(menuList[current.value]?.title), 1),
          _createElementVNode("div", _hoisted_2, [
            (current.value === 'CustomerManage')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {name: 'CustomerAdd'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menuList['CustomerAdd'].label), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})